define(['jquery', 'jquery.transit', 'modernizr', 'container'], function ($, transit, modernizr, container) {

    var scroll = function () {

        var publicVars = {};

        var privateVars = {
            name: 'scroll',

            disabled: new Map(),

            animatedElements: new Map(),

            tempAllowSection: ''
        };


        var privateMethods = {
            prepareObj: function (options) {

                publicVars = $.extend(true, publicVars, options);

                privateMethods.startup();
                privateMethods.bind();

            },
            startup: function () {

            },
            bind: function () {
                container.msg(privateVars.name + ' - module started');

                $(window).scroll(function () {

                    var ticking = false;

                    if (!ticking) {
                        window.requestAnimationFrame(function () {
                            try {
                                privateMethods.handleCurrentScrollPosition();
                            } catch(e) {
                                container.msg(name + ' scroll element error');
                            }
                            ticking = false;
                        });
                    }
                    ticking = true;

                });
            },

            handleCurrentScrollPosition: () => {

                if ($('body').hasClass('body-desktop')) {

                    const systemCurrentScroll = $(document).scrollTop();
                    const scrollPlusWindowHeight = $(window).height() + systemCurrentScroll;

                    privateVars.animatedElements.forEach((data) => {
                        privateMethods.handleElementVisible(
                            data.selector, data.section, systemCurrentScroll, scrollPlusWindowHeight, function () {
                                $(data.selector).removeClass('animate__animated');
                                $(data.selector).removeClass(data.cls);
                                $(data.selector).css({ visibility: 'hidden'});
                                setTimeout(() => {
                                    privateVars.disabled.set(data.selector, 0)
                                }, 300);
                            }, function () {
                                $(data.selector).addClass('animate__animated');
                                $(data.selector).addClass(data.cls);
                                $(data.selector).css({ visibility: 'visible'});
                                setTimeout(() => {
                                    privateVars.disabled.set(data.selector, 0)
                                }, 300);
                            });
                    });


                }
            },

            handleElementVisible: (targetPosSelector, section, systemCurrentScroll, scrollPlusWindowHeight, callbackOut, callbackIn) => {

                if ((!privateVars.disabled.has(targetPosSelector)
                    || privateVars.disabled.get(targetPosSelector) !== 1)
                    && (privateVars.tempAllowSection == '' || privateVars.tempAllowSection === section)) {
                    const targetPos = $(targetPosSelector).offset();
                    const rect = $(targetPosSelector)[0].getBoundingClientRect();

                    if (targetPos.top < scrollPlusWindowHeight &&
                        (scrollPlusWindowHeight < (targetPos.top + rect.height)
                            || systemCurrentScroll < (targetPos.top + rect.height))) {
                        if (typeof callbackIn === 'function') {
                            callbackIn();
                            privateVars.disabled.set(targetPosSelector, 1);
                        }
                    } else {
                        if (typeof callbackOut === 'function') {
                            callbackOut();
                            //privateVars.disabled.set(targetPosSelector, 1);
                        }
                    }
                }
            },

            registerAnimatedElement: function (selector, cls, section, options) {
                privateVars.animatedElements.set(selector, {
                    selector: selector,
                    cls: cls,
                    section: section,
                    options: options
                })
            },

            disable: function(allowSection) {
                privateVars.tempAllowSection = allowSection;
            },

            enable: function() {
                privateVars.tempAllowSection = '';
            }


        };


        var publicObj = {
            init: function (options) {
                privateMethods.prepareObj(options);
            },
            registerAnimatedElement: function (selector, cls, section, options) {
                privateMethods.registerAnimatedElement(selector, cls, section, options);
            },
            
            disable: function(allowSection) {
                privateMethods.disable(allowSection);
            },
            
            enable: function () {
                privateMethods.enable();
            }

        }

        return publicObj;
    }();

    return scroll;

});

/*
 ---
 ---
 scroll.registerAnimatedElement('.some-class', 'fadeIn', {});
 ---
 */